import React from 'react';

const TableName = ({ table_name = "" }) => {
  // Split the table name on periods
  const parts = table_name.split('.');
  
  // Handle cases where we might not have exactly 3 parts
  const database = parts[0] || '';
  const schema = parts[1] || '';
  const tableName = parts[2] || '';
  
  return (
    <div className="">
      <div className="">
        <small className="text-muted">{database && schema ? `${database}.${schema}` : table_name}</small>
        
      </div>
      <div className="text-xl font-bold text-slate-900 overflow-ellipsis">
        <h3 title={tableName || table_name} className="overflow-ellipsis mb-0">{tableName || table_name}</h3>
      </div>
    </div>
  );
};

export default TableName;

